import {combineRgb} from "#material/nodes/converter/combine-rgb/shorthand"
import {add, mul, sub} from "#material/nodes/converter/scalar-math/shorthands"
import {separateRgb} from "#material/nodes/converter/separate-rgb/shorthand"
import type {InputMaterialConnection} from "#material/sockets/definition"

export function rotateNormalMapVector(normalMap: InputMaterialConnection<"color">, angleDegrees: number): InputMaterialConnection<"color"> {
    // increasing angleDegrees will rotate the vector CCW around the Z axis
    if (angleDegrees == 0) return normalMap
    const theta = (angleDegrees * Math.PI) / 180
    const {r: nr, g: ng, b: nb} = separateRgb(normalMap)
    const nx = sub(nr, 0.5)
    const ny = sub(ng, 0.5)
    const s = Math.sin(theta)
    const c = Math.cos(theta)
    return combineRgb(add(add(mul(nx, c), mul(ny, s)), 0.5), add(sub(mul(ny, c), mul(nx, s)), 0.5), nb)
}
